import PageLayer from "@Layouts/views/PageLayer";
import MyIncentives from "@Motivators/components/MyMotivators";

import MyIncentivesIcon from "@/assets/icons/motivators/myMotivators/MyIncentives.svg";

export default function MyIncentivesView() {
	return (
		<PageLayer title="My Motivators" icon={MyIncentivesIcon}>
			<MyIncentives />
		</PageLayer>
	);
}
